import logo from './logo.svg';
import { Provider } from './context.js';
import { RoutesMain } from './components/RoutesMain';
import { ConfigProvider } from 'antd';
import ant_theme from './ant_theme.json';
import './misha.css';
import './add.css';
import './translate.css';


function App() {
  return (

      <Provider>
        <ConfigProvider
          theme={ant_theme}
        >
          <RoutesMain />
        </ConfigProvider>
      </Provider>

  );
}

export default App;
